import { render, staticRenderFns } from "./costothersubject.vue?vue&type=template&id=66ea8da4&scoped=true&"
import script from "./costothersubject.vue?vue&type=script&lang=js&"
export * from "./costothersubject.vue?vue&type=script&lang=js&"
import style0 from "./costothersubject.vue?vue&type=style&index=0&id=66ea8da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea8da4",
  null
  
)

export default component.exports